import { apiBlob, apiRequest } from '@/lib/apiClient';
import type { MapaMensal } from '@/types';

export function fetchMapaMensal(mes: string, userId?: string, obraId?: string): Promise<MapaMensal> {
  const search = new URLSearchParams({ mes });
  if (userId) search.set('userId', userId);
  if (obraId) search.set('obraId', obraId);
  return apiRequest<MapaMensal>(`/api/mapas/mensal?${search}`);
}

export function exportMapaMensalPdf(mes: string, userId?: string) {
  const search = new URLSearchParams({ mes });
  if (userId) search.set('userId', userId);
  return apiBlob(`/api/mapas/mensal/pdf?${search}`);
}

export function exportMapaMensal(mes: string, userId?: string) {
  const search = new URLSearchParams({ mes });
  if (userId) search.set('userId', userId);
  return apiBlob(`/api/mapas/mensal/export?${search}`);
}
